import React from 'react';
import { Copy, Link } from '@grubhubprod/gh-cookbook-react';
import { TieredAccountCell } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountCell/TieredAccountCell';
import { TieredAccountRow } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountRow/TieredAccountRow';
import { CORP_SIGN_UP_TYPE } from 'src/components/AuthProvider/AuthProvider';
import { getHomePath } from 'src/constants/urls';

interface CorporateAccountsRowProps {
  name: string;
  corpId: string;
  accountType: CORP_SIGN_UP_TYPE;
}

export const CorporateAccountsRow: React.FC<CorporateAccountsRowProps> = ({
  name,
  corpId,
  accountType,
}) => {
  const signupTypeLabelsMap = {
    [CORP_SIGN_UP_TYPE.PREMIUM]: 'Enterprise',
    [CORP_SIGN_UP_TYPE.BASIC]: 'Standard',
  };
  const getSignupType = (type: CORP_SIGN_UP_TYPE) =>
    signupTypeLabelsMap[type] || '';

  const corpUrlMap = {
    [CORP_SIGN_UP_TYPE.PREMIUM]: getHomePath(corpId),
    [CORP_SIGN_UP_TYPE.BASIC]: `/corporate/management/${corpId}/home`,
  };
  return (
    <TieredAccountRow>
      <TieredAccountCell width={6}>
        <Link href={corpUrlMap[accountType]}>{name}</Link>
      </TieredAccountCell>
      <TieredAccountCell width={6}>
        <Copy variant="body">{getSignupType(accountType)}</Copy>
      </TieredAccountCell>
    </TieredAccountRow>
  );
};
